import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import LogoCarousel from '../components/LogoCarousel';
import WhyChooseUs from '../components/WhyChooseUs';
import AreasSection from '../components/AreasSection';
import DevelopersSection from '../components/DevelopersSection';
import ProjectsSection from '../components/ProjectsSection';
import TeamSection from '../components/TeamSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <LogoCarousel />
        <WhyChooseUs />
        <AreasSection />
        <DevelopersSection />
        <ProjectsSection />
        <TeamSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

export default Home;
